import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

/**
 * `recordAssetView` request params\
 * (what is used to send to server)
 */
export type RecordAssetViewRequestOptions = {
	id: number;
};

/**
 * `recordAssetView` request\
 * (what gets sent to the server)
 */
export type RecordAssetViewRequest = [RecordAssetViewRequestOptions['id']];

/**
 * `recordAssetView` response\
 * (what comes back from the server)
 */
export type RecordAssetViewResponse = SuccessResponse<RecordAssetViewResult>;

/**
 * `recordAssetView` result\
 * (what is utilized from the server response)
 */
export type RecordAssetViewResult = void;

export const recordAssetViewEndpoint = 'recordAssetView';

/**
 * Notify that asset was viewed
 * @param fetchParams Fetch params
 */
export const recordAssetView = async ({id}: RecordAssetViewRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: RecordAssetViewRequest = [id];

	return client
		.post<RecordAssetViewResponse>(recordAssetViewEndpoint, requestParams)
		.then((response) => response.data.result);
};

export default recordAssetView;
